import {
  DeviceLastMessageActions,
  DeviceActionTypes,
} from './device-last-message.actions';
import { DeviceLastMessageStateInterface } from './device-last-message.model';


export const DeviceLastMessageInitialState: DeviceLastMessageStateInterface = {
  page: 1,
  pageCount: 1,
  itemCount: 1,
  itemTotal: 1,
  errors: [],
  filters: null,
  getDeviceLastMessageLoading: false,
  getDeviceLastMessageLoaded: false,
  deviceLastMessageData: [],
};

export function deviceLastMessageReducer(state = DeviceLastMessageInitialState, action: DeviceLastMessageActions): DeviceLastMessageStateInterface {
  switch (action.type) {
    case DeviceActionTypes.GetDeviceLastMessages:
      return {
        ...state,
        getDeviceLastMessageLoading: true,
        getDeviceLastMessageLoaded: false,
      };
    case DeviceActionTypes.GetDeviceLastMessagesCompleted:
      return {
        ...state,
        getDeviceLastMessageLoading: false,
        getDeviceLastMessageLoaded: true,
        deviceLastMessageData: action.messageList,
        itemTotal: action.itemTotal,
      };

    case DeviceActionTypes.ClearState:
      return { ...DeviceLastMessageInitialState };

    case DeviceActionTypes.FetchError:
      return {
        ...state,
        errors: action.payload,
      };

    default:
      return state;
  }
}
